<template>
  <div class="anti-fraud-message">
    <p>
      <i
        ><strong>Be alert for scams.</strong> WNYC never asks for nor accepts
        money for coverage or interviews. Anyone making such a request does not
        represent WNYC.</i
      >
    </p>
  </div>
</template>
